import { Flex } from '@wegroup/design-system';
import React from 'react';
import styled from 'styled-components';
import Avatar from '../../default/ProdFacAvatar';
import AssistantText from './AssistantText';

interface Props {
  title: string;
  description: string;
}

const AssistantTextWithAvatar: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  ...otherProps
}) => {
  return (
    <Flex {...otherProps}>
      <StyledAvatar />
      <AssistantText
        title={title}
        description={description}
        fontSize="3.2rem"
        maxWidth="90.8rem"
      />
    </Flex>
  );
};

const StyledAvatar = styled(Avatar)`
  width: 7.6rem;
  height: 7.6rem;

  margin-right: 2.4rem;
`;

export default AssistantTextWithAvatar;
